import { Injectable } from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment'; 
import { ComunaModel } from '../../models/comuna.model';

@Injectable({
  providedIn: 'root'
})
export class ComunaService {

  url: string;

  constructor(protected http: HttpClient) { 
    this.url = environment.urlApi + '/comunas';
  }

  getComunas(apikey: string, hash: string): Observable<ComunaModel[]> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
      headers = headers.append('accept', 'application/json'); 
      headers = headers.append('xApiKeyPublic', apikey);
    return this.http.get<ComunaModel[]>(this.url,{headers});
  }
}
